// Switches for features that are hidden but kept, so they can be turned back on
// without rebuilding them. Tests can flip these to cover both states.
export const features = {
  // the class whiteboard in chat (client feedback F6, 13 October 2026).
  // The data, save logic and rules are untouched; set to true to bring it back.
  whiteboard: false,
};
